export default "/images/vendor/flag-icons/flags/1x1/kr.svg?6682166bbe7bc0544876de60f37afe84";